import { useSalesTaxFilingDetail } from '@commenda/api';
import { useCallback } from 'react';
import { parseSalesTaxApiFilingDataToStandardFilingData } from './useSalesTaxFilingList';

export const useSalesTaxFilingDetails = ({
  filingId,
  corporationId,
}: {
  filingId: string;
  corporationId: number;
}) => {
  const {
    filing: salesTaxFiling,
    isLoading,
    error,
    mutate: refetchFilingBase,
  } = useSalesTaxFilingDetail({
    filingId,
    corporationId,
    includeServiceRequest: true,
    includeAgent: true,
    includeAssignee: true,
  });

  const filing = salesTaxFiling
    ? parseSalesTaxApiFilingDataToStandardFilingData(salesTaxFiling)
    : undefined;

  const refetchFiling = useCallback(() => {
    return refetchFilingBase();
  }, [refetchFilingBase]);

  return {
    filing,
    isLoading,
    error,
    refetchFiling,
  };
};
